"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WhiteLabelFeatureConfigurationProvider = (function () {
    function WhiteLabelFeatureConfigurationProvider(whiteLabelFeatureName, mapper) {
        this.whiteLabelFeatureName = whiteLabelFeatureName;
        this.mapper = mapper;
    }
    WhiteLabelFeatureConfigurationProvider.prototype.getConfiguration = function (resolverFactory) {
        var whiteLabelFeatureConfig = resolverFactory
            .getConfigLookupResolver()
            .getBy(this.whiteLabelFeatureName);
        return whiteLabelFeatureConfig
            ? this.mapper(whiteLabelFeatureConfig)
            : undefined;
    };
    return WhiteLabelFeatureConfigurationProvider;
}());
exports.default = WhiteLabelFeatureConfigurationProvider;
